module.exports = __webpack_public_path__ + "static/media/Podcast-banner.b8aa3d78.svg";